import { Route } from '@angular/router';
import { OperationsComponent } from './components/operations/operations.component';
import { OptimizerTabComponent } from './components/optimizer/optimizer-tab/optimizer-tab.component';
import { OptimizerSettingsComponent } from './components/optimizer/optimizer-settings/optimizer-settings.component';
import { OptimizerLogsComponent } from './components/optimizer/optimizer-logs/optimizer-logs.component';
import { RegionsComponent } from './components/regions/regions.component';
import { HolidaysModuleLoad } from '../holidays/holidays.routes';
import { keycloakGuard } from '@peca/keycloak';
import { CommercialRestrictComponent } from './components/commercial-restrict/commercial-restrict.component';
import { CommercialRestrictFormComponent } from './components/commercial-restrict-form/commercial-restrict-form.component';
import { AnyMarketComponent } from './components/anymarket-settings/anymarket.component';
import { AnyMarketSettingsComponent } from './components/anymarket-settings/settings/anymarket-settings.component';
import { AnyMarketPublisherComponent } from './components/anymarket-settings/publisher/anymarket-publisher.component';
import { ProductGroupDefaultListComponent } from './components/product-group-defaults/list/product-group-default-list.component';
import { ProductGroupDefaultFormComponent } from './components/product-group-defaults/form/product-group-default-form.component';

export const routes: Route[] = [
  {
    path: 'otimizador',
    component: OptimizerTabComponent,
    children: [
      { path: '', redirectTo: 'configuracoes', pathMatch: 'full' },
      { path: 'configuracoes', component: OptimizerSettingsComponent },
      { path: 'logs', component: OptimizerLogsComponent },
    ],
  },
  {
    path: 'regioes',
    component: RegionsComponent,
  },
  {
    path: 'feriados',
    loadChildren: HolidaysModuleLoad,
    canActivate: [keycloakGuard(['compras-listagem'])],
  },
  {
    path: 'restricao-vendedores',
    children: [
      { path: '', component: CommercialRestrictComponent },
      { path: 'novo', component: CommercialRestrictFormComponent },
      { path: ':id', component: CommercialRestrictFormComponent },
    ],
  },
  {
    path: 'anymarket',
    children: [
      { path: '', component: AnyMarketComponent },
      { path: 'configuracoes', component: AnyMarketSettingsComponent },
      { path: 'publicacoes', component: AnyMarketPublisherComponent },
    ]
  },
  {
    path: 'padroes-grupo-produtos',
    children: [
      { path: '', component: ProductGroupDefaultListComponent },
      { path: 'novo', component: ProductGroupDefaultFormComponent },
      { path: ':id', component: ProductGroupDefaultFormComponent },
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    component: OperationsComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

export const OperationsModuleLoad = () => import('./operations.module').then(({ OperationsModule }) => OperationsModule);
